(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    (function () {
    var VARIANT_CLASS = 'ab-product-header-top';
    var PENDING_CLASS = 'ab-ph-pending';
    var REVIEW_SELECTOR = '.shopify-app-block';
    var mobile = window.matchMedia('(max-width: 1079px)');
    var placeholder = null;
    var secondaryName = null;
    var secondaryPlaceholder = null;
    var reviewBlock = null;
    var reviewPlaceholder = null;
    var priceBlock = null;
    var pricePlaceholder = null;

    function personalizableDetails() {
      return document.querySelector('.product-details[data-personalizable="true"]');
    }

    function tagProductHeader() {
      if (document.getElementById('product-header')) return;

      var breadcrumbs = document.getElementById('breadcrumbs-container');
      if (!breadcrumbs) return;

      var next = breadcrumbs.nextElementSibling;
      if (next) {
        next.id = 'product-header';
      }
    }

    function cacheSecondaryName() {
      if (secondaryName) return;
      var breadcrumbs = document.getElementById('breadcrumbs-container');
      if (!breadcrumbs) return;
      secondaryName = breadcrumbs.querySelector('.product-secondary-name');
    }

    function restoreSecondaryName() {
      if (!secondaryName || !secondaryPlaceholder || !secondaryPlaceholder.parentNode) return;
      if (secondaryName.previousSibling === secondaryPlaceholder) return;

      secondaryPlaceholder.parentNode.insertBefore(secondaryName, secondaryPlaceholder.nextSibling);
    }

    function isBundlePdp() {
      return document.querySelector('.product-information__media--bundle') !== null;
    }

    function cacheReviewBlock() {
      if (reviewBlock) return;
      var header = document.getElementById('product-header');
      if (!header) return;
      reviewBlock = header.querySelector(REVIEW_SELECTOR);
    }

    function moveToMobile() {
      var header = document.getElementById('product-header');
      var wrapper = document.querySelector('.breadcrumbs-mobile-wrapper');
      if (!header || !wrapper) return;

      if (!placeholder) {
        placeholder = document.createComment('product-header-anchor');
        header.parentNode.insertBefore(placeholder, header);
      }

      if (secondaryName) {
        if (!secondaryPlaceholder) {
          secondaryPlaceholder = document.createComment('product-secondary-name-anchor');
          secondaryName.parentNode.insertBefore(secondaryPlaceholder, secondaryName);
        }
        if (secondaryName.previousElementSibling !== wrapper) {
          wrapper.insertAdjacentElement('afterend', secondaryName);
        }
        if (header.previousElementSibling !== secondaryName) {
          secondaryName.insertAdjacentElement('afterend', header);
        }
      } else if (header.previousElementSibling !== wrapper) {
        wrapper.insertAdjacentElement('afterend', header);
      }
    }

    function handleVariantUpdate(event) {
      var detail = event.detail;
      var isNewProduct = Boolean(detail && detail.data && detail.data.newProduct);

      if (isNewProduct) {
        placeholder = null;
        secondaryName = null;
        secondaryPlaceholder = null;
        reviewBlock = null;
        reviewPlaceholder = null;
        priceBlock = null;
        pricePlaceholder = null;
        init();
        return;
      }

      apply();
    }

    function restore() {
      restoreSecondaryName();

      var header = document.getElementById('product-header');
      if (!header || !placeholder || !placeholder.parentNode) return;
      if (header.previousSibling === placeholder) return;

      placeholder.parentNode.insertBefore(header, placeholder);
    }

    function ensureReviewPlaceholder() {
      if (reviewPlaceholder || !reviewBlock || !reviewBlock.parentNode) return;
      reviewPlaceholder = document.createComment('product-review-anchor');
      reviewBlock.parentNode.insertBefore(reviewPlaceholder, reviewBlock);
    }

    function moveReviewsBetweenVariants() {
      if (isBundlePdp() || !reviewBlock) return;

      var picker = document.querySelector('variant-picker[data-template-product-match="true"]');
      var sizeFieldset = picker
        ? picker.querySelector('fieldset[data-fieldset-option-position="2"]')
        : null;

      if (sizeFieldset) {
        var previous = sizeFieldset.previousElementSibling;
        var anchor =
          previous && previous.classList.contains('exposed-fit-note') ? previous : sizeFieldset;

        if (anchor.previousElementSibling === reviewBlock) return;
        ensureReviewPlaceholder();
        anchor.parentNode.insertBefore(reviewBlock, anchor);
        return;
      }

      var colorFieldset = picker
        ? picker.querySelector('fieldset[data-fieldset-option-position="1"]')
        : null;

      if (colorFieldset) {
        var starsAnchor = picker.querySelector('[data-pdp-price-below-swatches]') || colorFieldset;
        if (starsAnchor.nextElementSibling === reviewBlock) return;
        ensureReviewPlaceholder();
        starsAnchor.insertAdjacentElement('afterend', reviewBlock);
        return;
      }

      var breadcrumbs = document.getElementById('breadcrumbs-container');
      if (!breadcrumbs || breadcrumbs.nextElementSibling === reviewBlock) return;
      ensureReviewPlaceholder();
      breadcrumbs.insertAdjacentElement('afterend', reviewBlock);
    }

    function restoreReviews() {
      if (!reviewBlock || !reviewPlaceholder || !reviewPlaceholder.parentNode) return;
      if (reviewBlock.previousSibling === reviewPlaceholder) return;

      reviewPlaceholder.parentNode.insertBefore(reviewBlock, reviewPlaceholder.nextSibling);
    }

    function cachePriceBlock() {
      if (priceBlock || !personalizableDetails()) return;
      var header = document.getElementById('product-header');
      if (!header) return;
      priceBlock = header.querySelector('product-price');
    }

    function ensurePricePlaceholder() {
      if (pricePlaceholder || !priceBlock || !priceBlock.parentNode) return;
      pricePlaceholder = document.createComment('product-price-anchor');
      priceBlock.parentNode.insertBefore(pricePlaceholder, priceBlock);
    }

    function movePriceBelowGallery() {
      if (!priceBlock) return;

      var breadcrumbs = document.getElementById('breadcrumbs-container');
      if (!breadcrumbs || breadcrumbs.nextElementSibling === priceBlock) return;

      ensurePricePlaceholder();
      breadcrumbs.insertAdjacentElement('afterend', priceBlock);
    }

    function restorePrice() {
      if (!priceBlock || !pricePlaceholder || !pricePlaceholder.parentNode) return;
      if (priceBlock.previousSibling === pricePlaceholder) return;

      pricePlaceholder.parentNode.insertBefore(priceBlock, pricePlaceholder.nextSibling);
    }

    function reveal() {
      document.documentElement.classList.remove(PENDING_CLASS);
    }

    function swapReviewsAndPrice() {
      var details = personalizableDetails();
      if (!details || details.dataset.reviewsPriceSwapped === 'true') return;

      var price = details.querySelector('product-price');
      var stars = details.querySelector('[id*="yotpo_product_reviews_star_rating"]');
      if (!price || !stars) return;

      var priceParent = price.parentNode;
      var starsParent = stars.parentNode;
      if (!priceParent || !starsParent) return;

      var priceNext = price.nextSibling;
      var starsNext = stars.nextSibling;

      priceParent.insertBefore(stars, priceNext);
      starsParent.insertBefore(price, starsNext);

      details.dataset.reviewsPriceSwapped = 'true';
    }

    function apply() {
      if (document.body.classList.contains(VARIANT_CLASS) && mobile.matches) {
        moveToMobile();
        moveReviewsBetweenVariants();
        movePriceBelowGallery();
      } else {
        restorePrice();
        restoreReviews();
        restore();
      }
      reveal();
    }

    function init() {
      swapReviewsAndPrice();
      tagProductHeader();
      cacheSecondaryName();
      cacheReviewBlock();
      cachePriceBlock();
      apply();
    }

    function handleProductSwitch(event) {
      if (event.target !== document) return;
      var detail = event.detail;
      if (!detail || !detail.data || !detail.data.newProduct) return;

      placeholder = null;
      secondaryName = null;
      secondaryPlaceholder = null;
      priceBlock = null;
      pricePlaceholder = null;
      init();
    }

    // Run immediately so mobile swatch/size spacing is finalized before first paint.
    // Keep a DOMContentLoaded pass as a safety net in case required nodes are not yet present.
    init();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    }

    mobile.addEventListener('change', apply);
    document.addEventListener('variant:update', handleVariantUpdate);
    document.addEventListener('variant:update', handleProductSwitch);

    document.addEventListener('variant:update', function () {
      requestAnimationFrame(function () {
        var details = personalizableDetails();
        if (!details || details.dataset.reviewsPriceSwapped === 'true') return;
        placeholder = null;
        secondaryName = null;
        secondaryPlaceholder = null;
        priceBlock = null;
        pricePlaceholder = null;
        init();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-info"] && !Shopify.designMode) return;
  try {
    (function () {
    const hoursElements = document.querySelectorAll('.contact-info__hours-status[data-hours]');

    hoursElements.forEach((element) => {
      const hoursText = element.dataset.hours;
      const isOpen = checkIfOpen(hoursText);
      element.dataset.open = isOpen;
    });

    function checkIfOpen(hoursText) {
      try {
        // Get current time in EST
        const now = new Date();
        const estTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const currentDay = estTime.getDay(); // 0 = Sunday, 1 = Monday, etc.
        const currentHour = estTime.getHours();
        const currentMinutes = estTime.getMinutes();
        const currentTimeInMinutes = currentHour * 60 + currentMinutes;

        // Parse hours string like "Monday - Friday 10AM - 6PM EST"
        const lines = hoursText.split(/\n|<br\s*\/?>/i);

        for (const line of lines) {
          const trimmedLine = line.trim();
          if (!trimmedLine) continue;

          // Match pattern: "Day - Day HH:MM AM/PM - HH:MM AM/PM" or "Day HH:MM AM/PM - HH:MM AM/PM"
          const dayRangeMatch = trimmedLine.match(
            /(\w+)\s*-\s*(\w+)\s+(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\s*-\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i,
          );
          const singleDayMatch = trimmedLine.match(
            /^(\w+)\s+(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\s*-\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i,
          );

          if (dayRangeMatch) {
            const [, startDay, endDay, openHour, openMin, openPeriod, closeHour, closeMin, closePeriod] = dayRangeMatch;
            const startDayNum = getDayNumber(startDay);
            const endDayNum = getDayNumber(endDay);

            if (isDayInRange(currentDay, startDayNum, endDayNum)) {
              const openTime = parseTime(parseInt(openHour), parseInt(openMin || 0), openPeriod);
              const closeTime = parseTime(parseInt(closeHour), parseInt(closeMin || 0), closePeriod);

              if (currentTimeInMinutes >= openTime && currentTimeInMinutes < closeTime) {
                return true;
              }
            }
          } else if (singleDayMatch) {
            const [, day, openHour, openMin, openPeriod, closeHour, closeMin, closePeriod] = singleDayMatch;
            const dayNum = getDayNumber(day);

            if (currentDay === dayNum) {
              const openTime = parseTime(parseInt(openHour), parseInt(openMin || 0), openPeriod);
              const closeTime = parseTime(parseInt(closeHour), parseInt(closeMin || 0), closePeriod);

              if (currentTimeInMinutes >= openTime && currentTimeInMinutes < closeTime) {
                return true;
              }
            }
          }
        }

        return false;
      } catch (e) {
        console.error('Error parsing hours:', e);
        return false;
      }
    }

    function getDayNumber(dayName) {
      const days = {
        sunday: 0,
        sun: 0,
        monday: 1,
        mon: 1,
        tuesday: 2,
        tue: 2,
        tues: 2,
        wednesday: 3,
        wed: 3,
        thursday: 4,
        thu: 4,
        thur: 4,
        thurs: 4,
        friday: 5,
        fri: 5,
        saturday: 6,
        sat: 6,
      };
      return days[dayName.toLowerCase()] ?? -1;
    }

    function isDayInRange(currentDay, startDay, endDay) {
      if (startDay <= endDay) {
        return currentDay >= startDay && currentDay <= endDay;
      } else {
        // Wraps around week (e.g., Friday - Monday)
        return currentDay >= startDay || currentDay <= endDay;
      }
    }

    function parseTime(hour, minutes, period) {
      let h = hour;
      if (period.toUpperCase() === 'PM' && hour !== 12) {
        h += 12;
      } else if (period.toUpperCase() === 'AM' && hour === 12) {
        h = 0;
      }
      return h * 60 + minutes;
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
